'use strict';

/**
 *
 * @name: qqShare
 *
 */

function QqShareDirective($rootScope, $location, campaignTrackingServ) {

  'ngInject';

  return {
    restrict: 'A',
    link: function(scope, element, attrs) {

      element.click(function() {

        var descriptionText;

        if (attrs.description) {

          descriptionText = attrs.description;
        }

        var width = 575;
        var height = 400;
        var left = ($(window).width() - width) / 2;
        var top = ($(window).height() - height) / 2;
        var url;

        if (scope.post) {

          url = 'http://v.t.qq.com/share/share.php' +
            '?url=' + encodeURIComponent($location.protocol() + '://' + $location.host() + $location.path()) + campaignParams() +
            '&title=' + (scope.post.translations[$rootScope.lang].socialTitle ? encodeURIComponent(scope.post.translations[$rootScope.lang].socialTitle) : encodeURIComponent(scope.post.translations[$rootScope.lang].title));
        }

        if (scope.settings.singlePlaylist && !scope.settings.change) {

          url = 'http://v.t.qq.com/share/share.php' +
            '?url=' + encodeURIComponent($location.protocol() + '://' + $location.host() + $location.path()) + campaignParams() +
            '&title=' + (scope.cache.translations[$rootScope.lang].socialTitle ? encodeURIComponent(scope.cache.translations[$rootScope.lang].socialTitle) : encodeURIComponent(scope.cache.translations[$rootScope.lang].title));
        }

        function campaignParams() {

          if (attrs.trackingUrl && attrs.trackingUrl.toLowerCase() === 'true') {

            var medium = attrs.trackingUrlMedium || 'desktop';

            return '?' + encodeURIComponent(campaignTrackingServ.generateTrackingParams('qq', medium, 'share'));
          }
          return '';
        }

        var opts = 'status=1' +
          ',width=' + width +
          ',height=' + height +
          ',top=' + top +
          ',left=' + left;

        window.open(url, 'Tencent QQ', opts);

        return false;
      });
    }
  };
}

export default QqShareDirective;



// WEBPACK FOOTER //
// ./app/components/nn-social/nn-qq-share.directive.js